import { useEffect, useState } from "react";
import { urlAndDocumentFolder } from "../constants/urlAndDocumentsMapping";
import "../styles/document.css";

import {
  getParentFolder,
  getChildFolder,
  getDocuments
} from "../service/documentService";

const DocumentList = () => {
  const [documents, setDocuments] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    async function loadDocuments() {
      console.log("🚀 DocumentList mounted");


      // 2️⃣ Friendly URL
      const friendlyUrl = window.Liferay.ThemeDisplay
        .getLayoutRelativeURL()
        .toLowerCase();

      console.log("🌍 Friendly URL:", friendlyUrl);

      // 3️⃣ URL → folder mapping
      console.log("📦 URL–Folder Mapping:", urlAndDocumentFolder);

      const matchedConfig = urlAndDocumentFolder.find(item =>
        friendlyUrl.includes(item.url.toLowerCase())
      );

      console.log("🎯 Matched Config:", matchedConfig);

      if (!matchedConfig) {
        console.warn("⚠️ No folder mapping for this URL");
        return;
      }

      // 4️⃣ Group ID
      const groupId = window.Liferay.ThemeDisplay.getScopeGroupId();
      console.log("🏷️ Group ID:", groupId);

      // 5️⃣ Parent folder
      console.log("📁 Fetching parent folder...");
      const parentFolder = await getParentFolder(groupId, setError);
      console.log("📁 Parent Folder:", parentFolder);

      if (!parentFolder) {
        console.warn("❌ Parent folder not found");
        return;
      }

      // 6️⃣ Child folder
      console.log(
        `📂 Fetching child folder: ${matchedConfig.documentFolder}`
      );

      const stateFolder = await getChildFolder(
        parentFolder,
        matchedConfig,
        setError
      );

      console.log("📂 State Folder:", stateFolder);

      if (!stateFolder) {
        console.warn("❌ State folder not found");
        return;
      }

      // 7️⃣ Documents
      console.log("📄 Fetching documents...");
      const docsData = await getDocuments(stateFolder, setError);
      console.log("📄 Documents API Response:", docsData);

      if (!docsData) {
        console.warn("❌ No documents response");
        return;
      }

      console.log("📄 Documents Items:", docsData.items);

      // 8️⃣ Set state
      setDocuments(docsData.items || []);
      console.log("✅ Documents set in state");
    }

    loadDocuments();
  }, []);

  return (
  <div className="document-list">
  <ul className="document-ul">
    {documents.map(doc => (
      <li key={doc.id} className="document-li">
        <a
          href={doc.contentUrl}
          target="_blank"
          rel="noreferrer"
          className="document-link-inline"
        >
          <span className="document-title">
            {doc.description}
          </span>

          <img
            src="/documents/d/guest/pdf"
            alt="PDF"
            className="document-icon"
          />
        </a>
      </li>
    ))}
  </ul>
</div>


  );

};

export default DocumentList;
